export const DEFAULT_NUMBER_ADVANTAGES = 4
